import { Component, OnInit } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { AuthService } from "../../guards/auth/auth.service";
import { ActivatedRoute, Router } from '@angular/router';
import { ActivateService } from '../activate/activate.service';
import { RegisterModel } from '../register/register.model';

@Component({
    selector: 'convfact-forgot',
    templateUrl: './forgot.component.html',
    styleUrls: ['./forgot.component.scss'],
    standalone: false
})

export class ForgotComponent implements OnInit {
    email: string;
    password: string;
    activated: boolean = true;
    uid: string;
    ready: boolean = false;
    resetPassword: boolean = false;
    showNewPassword: boolean = false;

    constructor(private authService: AuthService, private activateService: ActivateService, private route: ActivatedRoute,
        private router: Router, public snackBar: MatSnackBar) {
    }

    showPassword(): void {
        this.showNewPassword = !this.showNewPassword;
    }

    login() {
        this.router.navigate(['/login']);
    }

    displayError(error: string): void {
        const options = new MatSnackBarConfig();
        options.duration = 10500;
        this.snackBar.open(error, '', options);
    }

    forgot(): void {
        const register = new RegisterModel;
        register.Username = this.email;
        this.authService.checkEmail(register).then(response => {
            this.displayError(response);
        }).catch(err => {
            this.displayError(err.message || 'No se ha podido procesar la solicitud');
        })
    }

    resetPass() {
        const register = new RegisterModel;
        register.Password = this.password;
        register.Uid = this.uid;
        this.authService.resetPassword(register).then(response => {
            this.displayError(response);
            this.router.navigate(['/login']);
        }).catch(err => {
            this.displayError(err.message || 'No se ha podido cambiar la contraseña');
        })
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.uid = params['uid'];
        })

        if (this.uid == undefined) {
            this.ready = true;
        }

        if (this.uid !== undefined) {
            if (this.uid.length == 36) {
                this.resetPassword = true;
            } else {
                this.router.navigate(['/login']);
            }
        }

    }
}
